export default "__VITE_ASSET__BB6Qh7Wf__"